module.exports = __webpack_public_path__ + "img/c_sv4.200032d.png";